import SignatureAudit from "../SignatureAudit";
import DdiAudit from "../medical/DdiAudit";
import ConfigurationLibrary from "../admin/ConfigurationLibrary";
import BaaTrackerSection from "./BaaTrackerSection";
import { V2Preview } from "../../components/V2Preview";

// Small helper: renders a "Preview" band that shows about half of the child
// content at full opacity, then fades the rest and stamps a "Version 2 - full
// experience coming soon" banner on top. Delegates to the shared V2Preview
// primitive in components/V2Preview.

export function SignatureAuditSection() {
  return (
    <V2Preview label="Signature Audit"
      description="Every e-signature captured across the clinic. Version 2 will add filter presets, saved reports, and cryptographic tamper alerts.">
      <SignatureAudit />
    </V2Preview>
  );
}

export function DdiAuditSection() {
  return (
    <V2Preview label="DDI Override Audit"
      description="Track every drug-drug interaction override and clinician acknowledgement. Version 2 will layer FDA plus RxNorm scoring on top.">
      <DdiAudit />
    </V2Preview>
  );
}

export function ConfigurationLibrarySection() {
  return (
    <V2Preview label="Configuration Library"
      description="Chart-note types, message templates, and program presets. Version 2 will add branching workflows, versioned templates, and per-role catalogs.">
      <ConfigurationLibrary />
    </V2Preview>
  );
}

export function BaaTrackerV2Preview() {
  return (
    <V2Preview label="BAA Tracker"
      description="Business Associate Agreements for every vendor that touches PHI. Version 2 will add renewal reminders, DocuSign integration, per-vendor risk scoring, and CARF-ready export bundles.">
      <BaaTrackerSection />
    </V2Preview>
  );
}
